import { tracked } from '@glimmer/tracking';
import { resource } from 'ember-resources';

// Holds the reactive match state; a fresh instance per `mediaQuery` resource.
class MediaQueryState {
  @tracked matches = false;
}

/**
 * Reactive `window.matchMedia`: `@use isLgUp = mediaQuery('(min-width: 64em)')`
 * reads a boolean that re-renders on resize. Defaults `true` off-browser so
 * nothing gets locked out in server/test contexts.
 */
export function mediaQuery(query: string): boolean {
  return resource<boolean>(({ on }: { on: { cleanup: (destructor: () => void) => void } }) => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return () => true;
    }

    const list = window.matchMedia(query);
    const state = new MediaQueryState();
    state.matches = list.matches;
    const onChange = (event: MediaQueryListEvent): void => {
      state.matches = event.matches;
    };

    list.addEventListener('change', onChange);
    on.cleanup(() => list.removeEventListener('change', onChange));

    return () => state.matches;
  });
}
